var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.995 8.094C19.995 3.631 15.51 0 9.997 0 4.484 0 0 3.63 0 8.094c0 4.002 3.564 7.351 8.361 7.986.326.07.77.214.881.492.102.252.066.646.032.902l-.142.847c-.044.252-.2.985.865.537 1.066-.45 5.758-3.375 7.86-5.783C19.307 11.49 20 9.88 20 8.095",
    transform: "translate(2 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B900",
    d: "M7.822 6h-.644c-.048 0-.093.022-.127.06C7.018 6.1 7 6.151 7 6.206v4.588c0 .113.08.205.178.206h.644c.099-.001.178-.093.178-.206V6.206c0-.055-.018-.107-.051-.146-.034-.038-.08-.06-.127-.06M12.834 6h-.684c-.105 0-.19.092-.19.206V8.93l-1.929-2.84c-.004-.008-.009-.015-.015-.021l-.004-.013L10 6.048h-.811c-.05 0-.099.021-.134.06-.036.039-.055.091-.055.146v4.54c0 .114.085.206.19.206h.678c.105-.001.189-.092.19-.206V8.07L12 10.912c.013.02.029.037.048.05l.013.01h.75c.104 0 .189-.093.189-.206v-4.56c0-.055-.02-.108-.055-.146-.035-.039-.084-.06-.134-.06M5.818 9.856H4.025v-3.65c0-.055-.019-.107-.053-.146C3.937 6.02 3.89 6 3.842 6h-.66c-.049 0-.095.022-.13.06C3.02 6.1 3 6.151 3 6.206v4.595c0 .053.018.104.051.142.034.036.08.056.126.057h2.641c.1-.001.182-.093.182-.206v-.732c0-.055-.019-.107-.053-.146-.034-.039-.08-.06-.129-.06M16.818 7.152c.1-.003.18-.096.179-.208v-.738c0-.112-.08-.203-.18-.206h-2.641c-.047 0-.092.02-.126.057-.032.039-.05.09-.05.142V10.8c0 .053.018.104.051.142.034.036.08.056.126.057h2.64c.102-.001.183-.093.183-.206v-.732c0-.055-.019-.107-.053-.146-.034-.039-.08-.06-.13-.06H15.02v-.778h1.798c.048 0 .095-.021.13-.06.033-.039.052-.091.052-.146v-.74c0-.112-.082-.203-.182-.203H15.02v-.777h1.798z",
    transform: "translate(2 2.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6246c6fd60341f3af2fe03165d0074b6.svg";
export { ForwardRef as ReactComponent };